import { useContext } from 'react';
import { BuildInAppToolId, IAppToolsContext } from '../types/appTools';
import AppToolsContext from '../context/AppToolsContext';
import {
    useActivitiesLiveStatus,
    useEvent,
    useSession,
    useVirtualSession,
} from '@bizzabo/entities';
import { isCollaborationAppEnabled } from '../utils/CollaborationAppIsEnabled';
import useWaitingRoom from '../../agenda/hooks/waitingRoom';
import { useEnabledAppTools } from '../../tools/decorators/useEnabledAppTools';

const CollaborationToolEnabled = ({ children }) => {
    const { eventUniqueName, sessionId } = useContext<IAppToolsContext>(AppToolsContext);
    const event = useEvent(eventUniqueName);
    const session = useSession(event.data?.id, sessionId);
    const virtualSession = useVirtualSession({
        eventId: event.data?.id,
        sessionId: sessionId,
    });

    const { isActive: isWaitingRoomActive } = useWaitingRoom(eventUniqueName, sessionId);

    const activitiesLiveStatus = useActivitiesLiveStatus(eventUniqueName);

    const isLoading =
        event.isLoading ||
        session.isLoading ||
        virtualSession.isLoading ||
        activitiesLiveStatus.isLoading;

    const isEnabled = isCollaborationAppEnabled(
        session,
        virtualSession,
        activitiesLiveStatus,
        isWaitingRoomActive
    );

    useEnabledAppTools(BuildInAppToolId.SessionChats, isEnabled);

    return children({ isLoading, isEnabled });
};

export default CollaborationToolEnabled;
